/**
 * Determines if a value truly is a number
 * @param {any} value
 */
export const isInt = (value) => {
  if (/^[-+]?(\d+|Infinity)$/.test(value)) {
    return Number(value)
  } else {
    return NaN
  }
}
